import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DisplayQuestionnaireComponent } from "./display-questionnaire.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GetControlModule } from "../get-control/get-control.module";
import { FileDetailsModule } from "app/pipes/file-details/file-details.module";
import { ProgressModule } from "app/shared/progress/progress.module";
import { DocumentViewerModule } from "app/shared/document-viewer/document-viewer.module";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { NgxLoadingModule } from "ngx-loading";
@NgModule({
  declarations: [DisplayQuestionnaireComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GetControlModule,
    FileDetailsModule,
    ProgressModule,
    DocumentViewerModule,
    PdfViewerModule,
    NgxLoadingModule,
  ],
  exports: [DisplayQuestionnaireComponent],
})
export class DisplayQuestionnaireModule {}
